import { render, staticRenderFns } from "./MobileNumberSetting.vue?vue&type=template&id=2f15554e"
import script from "./MobileNumberSetting.vue?vue&type=script&lang=ts"
export * from "./MobileNumberSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports